import React from 'react';

const withMemoization = (WrappedComponent) => {
  const MemoizedComponent = React.memo(WrappedComponent);

  const WrapperComponent = (props) => {
    // Puedes realizar operaciones adicionales aquí antes de pasar las props al componente envuelto.
    return <MemoizedComponent {...props} />;
  };

  return WrapperComponent;
};

export default withMemoization;
